
export const ACSR_PRODUCTS = [
  {
    id: 1,
    name: 'MOLE',
    size_specs: '6/1.50 (Aluminium) / 1/1.50 (Steel)',
    no_of_wires_aluminium: 6,
    no_of_wires_steel: 1,
    size_aluminium: 1.50,
    size_steel: 1.50,
    weight_aluminium: 29.22,
    weight_steel: 14.23,
    total_weight: 43.45,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 11.51,
    cost_conductor_commercial_per_mtr: 11.01,
    cost_conductor_isi_per_kg: 264.85,
    cost_conductor_commercial_per_kg: 253.38
  },
  {
    id: 2,
    name: 'SPECIAL',
    size_specs: '6/1.96 (Aluminium) / 1/1.96 (Steel)',
    no_of_wires_aluminium: 6,
    no_of_wires_steel: 1,
    size_aluminium: 1.96,
    size_steel: 1.96,
    weight_aluminium: 49.89,
    weight_steel: 24.30,
    total_weight: 74.19,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 19.65,
    cost_conductor_commercial_per_mtr: 18.80,
    cost_conductor_isi_per_kg: 264.85,
    cost_conductor_commercial_per_kg: 253.38
  },
  {
    id: 3,
    name: 'SQIRREL',
    size_specs: '6/1.96 (Aluminium) / 1/1.96 (Steel)',
    no_of_wires_aluminium: 6,
    no_of_wires_steel: 1,
    size_aluminium: 1.96,
    size_steel: 1.96,
    weight_aluminium: 49.89,
    weight_steel: 24.30,
    total_weight: 74.19,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 19.65,
    cost_conductor_commercial_per_mtr: 18.80,
    cost_conductor_isi_per_kg: 264.85,
    cost_conductor_commercial_per_kg: 253.38
  },
  {
    id: 4,
    name: 'WEASEL',
    size_specs: '6/2.59 (Aluminium) / 1/2.59 (Steel)',
    no_of_wires_aluminium: 6,
    no_of_wires_steel: 1,
    size_aluminium: 2.59,
    size_steel: 2.59,
    weight_aluminium: 87.11,
    weight_steel: 42.43,
    total_weight: 129.54,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 34.31,
    cost_conductor_commercial_per_mtr: 32.82,
    cost_conductor_isi_per_kg: 264.85,
    cost_conductor_commercial_per_kg: 253.38
  },
  {
    id: 5,
    name: 'RABBIT',
    size_specs: '6/3.35 (Aluminium) / 1/3.35 (Steel)',
    no_of_wires_aluminium: 6,
    no_of_wires_steel: 1,
    size_aluminium: 3.35,
    size_steel: 3.35,
    weight_aluminium: 145.73,
    weight_steel: 70.99,
    total_weight: 216.72,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 57.40,
    cost_conductor_commercial_per_mtr: 54.91,
    cost_conductor_isi_per_kg: 264.85,
    cost_conductor_commercial_per_kg: 253.38
  },
  {
    id: 6,
    name: 'RACCOON',
    size_specs: '6/4.09 (Aluminium) / 1/4.09 (Steel)',
    no_of_wires_aluminium: 6,
    no_of_wires_steel: 1,
    size_aluminium: 4.09,
    size_steel: 4.09,
    weight_aluminium: 217.23,
    weight_steel: 105.81,
    total_weight: 323.04,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 85.56,
    cost_conductor_commercial_per_mtr: 81.85,
    cost_conductor_isi_per_kg: 264.85,
    cost_conductor_commercial_per_kg: 253.38
  },
  {
    id: 7,
    name: 'DOG',
    size_specs: '6/4.72 (Aluminium) / 7/1.57 (Steel)',
    no_of_wires_aluminium: 6,
    no_of_wires_steel: 7,
    size_aluminium: 4.72,
    size_steel: 1.57,
    weight_aluminium: 289.30,
    weight_steel: 109.14,
    total_weight: 398.44,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 111.63,
    cost_conductor_commercial_per_mtr: 106.64,
    cost_conductor_isi_per_kg: 280.17,
    cost_conductor_commercial_per_kg: 267.63
  },
  {
    id: 8,
    name: 'WOLF',
    size_specs: '30/2.59 (Aluminium) / 7/2.59 (Steel)',
    no_of_wires_aluminium: 30,
    no_of_wires_steel: 7,
    size_aluminium: 2.59,
    size_steel: 2.59,
    weight_aluminium: 435.55,
    weight_steel: 297.03,
    total_weight: 732.57,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 177.72,
    cost_conductor_commercial_per_mtr: 170.46,
    cost_conductor_isi_per_kg: 242.60,
    cost_conductor_commercial_per_kg: 232.69
  },
  {
    id: 9,
    name: 'PANTHER',
    size_specs: '30/3.00 (Aluminium) / 7/3.00 (Steel)',
    no_of_wires_aluminium: 30,
    no_of_wires_steel: 7,
    size_aluminium: 3.00,
    size_steel: 3.00,
    weight_aluminium: 584.36,
    weight_steel: 398.51,
    total_weight: 982.87,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 238.45,
    cost_conductor_commercial_per_mtr: 228.70,
    cost_conductor_isi_per_kg: 242.60,
    cost_conductor_commercial_per_kg: 232.69
  },
  {
    id: 10,
    name: 'KUNDAH',
    size_specs: '42/3.50 (Aluminium) / 7/1.96 (Steel)',
    no_of_wires_aluminium: 42,
    no_of_wires_steel: 7,
    size_aluminium: 3.50,
    size_steel: 1.96,
    weight_aluminium: 1113.53,
    weight_steel: 170.10,
    total_weight: 1283.63,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 411.47,
    cost_conductor_commercial_per_mtr: 391.76,
    cost_conductor_isi_per_kg: 320.55,
    cost_conductor_commercial_per_kg: 305.20
  },
  {
    id: 11,
    name: 'ZEBRA',
    size_specs: '54/3.18 (Aluminium) / 7/3.18 (Steel)',
    no_of_wires_aluminium: 54,
    no_of_wires_steel: 7,
    size_aluminium: 3.18,
    size_steel: 3.18,
    weight_aluminium: 1181.85,
    weight_steel: 447.76,
    total_weight: 1629.62,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 456.17,
    cost_conductor_commercial_per_mtr: 435.77,
    cost_conductor_isi_per_kg: 279.93,
    cost_conductor_commercial_per_kg: 267.41
  },
  {
    id: 12,
    name: 'MOOSE',
    size_specs: '54/3.53 (Aluminium) / 7/3.53 (Steel)',
    no_of_wires_aluminium: 54,
    no_of_wires_steel: 7,
    size_aluminium: 3.53,
    size_steel: 3.53,
    weight_aluminium: 1456.33,
    weight_steel: 551.75,
    total_weight: 2008.08,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 562.12,
    cost_conductor_commercial_per_mtr: 536.98,
    cost_conductor_isi_per_kg: 279.93,
    cost_conductor_commercial_per_kg: 267.41
  },
  {
    id: 13,
    name: 'BERSIMIS',
    size_specs: '42/4.57 (Aluminium) / 7/2.54 (Steel)',
    no_of_wires_aluminium: 42,
    no_of_wires_steel: 7,
    size_aluminium: 4.57,
    size_steel: 2.54,
    weight_aluminium: 1898.44,
    weight_steel: 285.67,
    total_weight: 2184.11,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 701.20,
    cost_conductor_commercial_per_mtr: 667.58,
    cost_conductor_isi_per_kg: 321.05,
    cost_conductor_commercial_per_kg: 305.65
  },
  {
    id: 14,
    name: 'CUSTOM',
    size_specs: '0.00/0.00 (Aluminium) / 0/0.00 (Steel)',
    no_of_wires_aluminium: 0,
    no_of_wires_steel: 0,
    size_aluminium: 0.00,
    size_steel: 0.00,
    weight_aluminium: 0.00,
    weight_steel: 0.00,
    total_weight: 0.00,
    aluminium_cg_grade: 296.00,
    aluminium_ec_grade: 320.00,
    steel_rate: 65.00,
    cost_conductor_isi_per_mtr: 0.00,
    cost_conductor_commercial_per_mtr: 0.00,
    cost_conductor_isi_per_kg: 0.00,
    cost_conductor_commercial_per_kg: 0.00
  }
];

/**
 * Calculate all values for a product with dynamic rates
 */
export const calculateProductCosts = (product, aluminiumCgRate, aluminiumEcRate, steelRate) => {
  // Calculate weights using the specified formulas
  const weightAluminium = product.size_aluminium * product.size_aluminium * 0.785 * product.no_of_wires_aluminium * 1.02 * 2.703;
  const weightSteel = product.size_steel * product.size_steel * 0.785 * product.no_of_wires_steel * 1.02 * 7.9;
  const totalWeight = weightAluminium + weightSteel;
  
  // Calculate costs based on your specified formulas
  const costConductorIsiPerMtr = ((weightAluminium * aluminiumEcRate) + (weightSteel * steelRate)) * 1.12 / 1000;
  const costConductorCommercialPerMtr = ((weightSteel * steelRate) + (weightAluminium * aluminiumCgRate)) * 1.15 / 1000;
  
  // Calculate per KG costs
  const costConductorIsiPerKg = totalWeight > 0 ? costConductorIsiPerMtr * 1000 / totalWeight : 0;
  const costConductorCommercialPerKg = totalWeight > 0 ? costConductorCommercialPerMtr * 1000 / totalWeight : 0;

  return {
    ...product,
    weight_aluminium: weightAluminium,
    weight_steel: weightSteel,
    total_weight: totalWeight,
    aluminium_cg_grade: aluminiumCgRate,
    aluminium_ec_grade: aluminiumEcRate,
    steel_rate: steelRate,
    cost_conductor_isi_per_mtr: costConductorIsiPerMtr,
    cost_conductor_commercial_per_mtr: costConductorCommercialPerMtr,
    cost_conductor_isi_per_kg: costConductorIsiPerKg,
    cost_conductor_commercial_per_kg: costConductorCommercialPerKg,
  };
};

/**
 * Calculate all products with given rates
 */
export const calculateAllProducts = (aluminiumCgRate, aluminiumEcRate, steelRate) => {
  return ACSR_PRODUCTS.map(product =>
    calculateProductCosts(product, aluminiumCgRate, aluminiumEcRate, steelRate)
  );
};

// Default rates (will be overridden by actual rates from Account section)
export const DEFAULT_RATES = {
  aluminium_cg_grade: 296.00,
  aluminium_ec_grade: 320.00,
  steel_rate: 65.00,
};
